// import { createSlice } from "@reduxjs/toolkit";

// const ResidentialModalSlice = createSlice({
//   name: "ResidentialModal",
//   initialState: {
//     formData: {
//       floorType: "",
//       propertyArea: "",
//       constructionType: "",
//       constructionYear: "",
//       area: "",
//       rate: "",
//     },
//     Residentialshow: false, // Control the visibility of the modal
//   },
//   reducers: {
//     setFormData(state, action) {
//       state.formData = { ...state.formData, ...action.payload };
//     },
//     resetResidentialModalData(state) {
//       state.formData = {
//         floorType: "",
//         propertyArea: "",
//         constructionType: "",
//         constructionYear: "",
//         area: "",
//         rate: "",
//       };
//     },
//     // Action to show the modal
//     showResidentialModal(state) {
//       state.Residentialshow = true;
//     },
//     // Action to hide the modal
//     hideResidentialModal(state) {
//       state.Residentialshow = false;
//     },
//   },
// });

// export const {
//   setFormData,
//   resetResidentialModalData,
//   showResidentialModal,
//   hideResidentialModal,
// } = ResidentialModalSlice.actions;

// export default ResidentialModalSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formResiData: {
    floorType: "",
    propertyArea: "",
    constructionType: "",
    constructionYear: "",
    area: "",
    rate: "",
  },
  Residentialshow: false, // Control the visibility of the modal
};

const ResidentialModalSlice = createSlice({
  name: "ResidentialModal",
  initialState,
  reducers: {
    setFormResiData(state, action) {
      state.formResiData = { ...state.formResiData, ...action.payload };
    },
    resetResidentialModalData(state) {
      state.formResiData = {
        floorType: "",
        propertyArea: "",
        constructionType: "",
        constructionYear: "",
        area: "",
        rate: "",
      };
    },
    // Action to show the modal
    showResidentialModal(state) {
      state.Residentialshow = true;
    },
    // Action to hide the modal
    hideResidentialModal(state) {
      state.Residentialshow = false;
    },
  },
});

export const {
  setFormResiData,
  resetResidentialModalData,
  showResidentialModal,
  hideResidentialModal,
} = ResidentialModalSlice.actions;

export default ResidentialModalSlice.reducer;
